import { useState, useEffect, useCallback } from 'react';
import { useRouter } from 'next/router';
import { useFormikContext } from 'formik';
import { selectModelTypeFieldTypeInfo } from 'modules/Models/components/ModelForm/utils/utils';
import { useAuthState } from 'modules/Auth/AuthContext';
import { formContainer, inputContainer } from 'modules/Models/components/ModelForm/styles';
import { FormikInitialValues } from 'modules/Models/components/ModelForm/utils/types';
import { modelFormApiEffects } from 'modules/Models/components/ModelForm/utils/apiEffects';
import { conceptInnerContainer, conceptOuterContainer } from '../ConceptFormElement/ConceptFormElement.styles';
import { AnnotationUserAutocomplete } from './AnnotationUserAutocomplete';
import { FormLabel } from '../FormLabel';

type AnnotationUserIdFormElementProps = React.InputHTMLAttributes<HTMLInputElement> & { path: string };

export const AnnotationUserIdFormElement = ({ path }: AnnotationUserIdFormElementProps) => {
  const { values, setFieldValue } = useFormikContext();
  const { fieldValueMap } = values as FormikInitialValues;

  const {
    query: { appId },
  } = useRouter();

  const { authData } = useAuthState();
  const userId = authData && authData.user_id;
  const { description = '' } = selectModelTypeFieldTypeInfo(path, values as FormikInitialValues);
  const formInputValue = fieldValueMap[path];
  const [collaborators, setCollaborators] = useState<CF.API.Collaborators.Collaborator[]>([]);

  const fetchCollaborators = useCallback(async () => {
    const appCollaborators = await modelFormApiEffects.fetchAppCollaborators(appId as string, userId as string);
    setCollaborators(appCollaborators);
  }, [appId, userId]);

  useEffect(() => {
    fetchCollaborators();
  }, []);

  const handleSelectUserId = useCallback(
    (selectedUserId: CF.API.Collaborators.Collaborator) => {
      setFieldValue('fieldValueMap', { ...fieldValueMap, [path]: selectedUserId });
    },
    [fieldValueMap, path],
  );

  return (
    <div className={formContainer}>
      <div className={inputContainer}>
        <FormLabel path={path} description={description as string} />
        <div className={conceptOuterContainer}>
          <div className={conceptInnerContainer} />
        </div>
        {collaborators.length && <AnnotationUserAutocomplete setSelectedUserId={handleSelectUserId} value={formInputValue} users={collaborators} />}
      </div>
    </div>
  );
};
